mutation UserProfileDelete($input: UserProfileDeleteInput!) {
  userProfileDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
